export default "__VITE_ASSET__d4219c79__"